export enum Env {
  Production = 'prd',
  Staging = 'stg',
  Development = 'dev',
  UAT = 'uat',
}
